import React from 'react';
import { FiShield, FiTruck, FiMap } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const FeaturesBar = () => {
  const features = [
    { icon: FiShield, title: "LIFETIME WARRANTY", desc: "If it breaks, we replace it." },
    { icon: FiMap, title: "FIELD TESTED", desc: "Proven in extreme conditions." },
    { icon: FiTruck, title: "FREE EXPEDITION SHIPPING", desc: "On orders over $250." }
  ];

  return (
    <div className="bg-zinc-900 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-zinc-800">
          {features.map((feat, idx) => (
            <div key={idx} className="flex items-start gap-4 pt-4 md:pt-0 md:px-8 first:px-0">
              <SafeIcon icon={feat.icon} className="w-8 h-8 text-orange-600 flex-shrink-0" />
              <div>
                <h4 className="font-black uppercase tracking-widest text-sm mb-1">{feat.title}</h4>
                <p className="text-zinc-400 text-sm">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesBar;